var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInvalidNameGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ACB5BD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.004 677.998c1.093 0 2.122-.21 3.088-.633.965-.422 1.816-1 2.553-1.733.737-.733 1.313-1.582 1.73-2.547.417-.966.625-1.994.625-3.086 0-1.092-.21-2.12-.63-3.085-.418-.965-.996-1.816-1.733-2.552-.737-.737-1.588-1.314-2.554-1.733-.965-.42-1.995-.629-3.087-.629-1.093 0-2.12.21-3.083.629-.963.419-1.815.996-2.554 1.733-.74.736-1.317 1.587-1.734 2.552-.417.965-.625 1.993-.625 3.085 0 1.092.21 2.12.63 3.086.418.965.996 1.814 1.733 2.547.737.734 1.587 1.311 2.55 1.733.962.422 1.993.633 3.091.633zm0-1.365c-.921 0-1.784-.17-2.587-.513-.802-.342-1.506-.816-2.11-1.422-.604-.607-1.078-1.313-1.42-2.118-.342-.805-.513-1.665-.513-2.58 0-.916.171-1.777.513-2.582.342-.805.816-1.51 1.42-2.117s1.306-1.081 2.106-1.423c.8-.342 1.661-.513 2.583-.513.921 0 1.782.17 2.582.513.8.342 1.504.816 2.111 1.423.607.606 1.083 1.312 1.428 2.117.345.805.517 1.666.517 2.581.006.916-.164 1.776-.509 2.581-.345.805-.82 1.511-1.423 2.118-.605.606-1.308 1.08-2.111 1.422-.803.342-1.665.513-2.587.513zm-.008-5.228c.397 0 .599-.21.604-.628l.116-4.087c.006-.204-.062-.373-.203-.508-.14-.136-.316-.203-.525-.203-.216 0-.39.066-.526.198-.135.133-.2.3-.195.505l.1 4.095c.01.419.22.628.629.628zm0 2.548c.232 0 .432-.078.6-.236.168-.157.252-.351.252-.583 0-.231-.084-.426-.252-.583-.168-.157-.368-.236-.6-.236-.237 0-.439.08-.604.24-.166.16-.249.353-.249.58 0 .225.084.418.253.578.168.16.368.24.6.24z",
    transform: "translate(-62.000000, -662.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvalidNameGray);
export default __webpack_public_path__ + "static/media/ic_invalid_name_gray.50a5e90d699643e8501df47d27237f69.svg";
export { ForwardRef as ReactComponent };